import {Text} from '@mantine/core';
import {getIn, useFormikContext} from 'formik';

// An error on a whole list (no pricing unit, a term priced twice) has no input
// to hang it on. Shown once the operator has tried to submit.
export const FieldError = ({name}: { name: string }) => {
    const {errors, submitCount} = useFormikContext();
    const error = getIn(errors, name);

    if (submitCount === 0 || typeof error !== 'string') {
        return null;
    }

    return <Text c='red' size='sm' role='alert'>{error}</Text>;
};
